// @ts-check

import React from "react";
import { Image, InlineStack, Text } from "@shopify/polaris";

import { PLATFORM_LOGOS } from "utils/platform-connection";

export const Platform = ({
  platformKey,
  platformName,
  fontWeight = "regular",
}) => {
  return (
    <InlineStack gap="200">
      <Image source={PLATFORM_LOGOS[platformKey]} alt={platformName} width={20} height={20} />
      <Text as="p" variant="headingMd" fontWeight={fontWeight}>{platformName}</Text>
    </InlineStack>
  );
}
